









import { defineComponent } from "@vue/composition-api";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "StreamModal",
  components: { BaseSpinner, ModalView },
  props: {
    loading: { type: Boolean },
  },
});
